import util from "./_util";

const { request } = util;

export default {
  login(data) {
    console.log(data);
    return request.post("/User/Login", data);
  },

  login2(data){
    return request.post("/User/SetLoginToken", data);
  }

};
